const JourneyNotFound: React.FC = () => (
  <p>Journey not found</p>
);
export default JourneyNotFound;
